import type { SolicitacaoAtrasada } from '../solicitacoesDashboard.utils';

interface AtrasadasAgoraCardProps {
  itens: SolicitacaoAtrasada[];
  onSelect: (id: string) => void;
}

/** Lista, não gráfico — "quais exatamente" importa mais aqui do que "quantas" (é uma
 * lista de ação, não uma métrica de acompanhar tendência). Mesmo nível "urgente" já usado
 * no badge de alerta em qualquer outro lugar da tela (SolicitacaoRow, etc.). */
export default function AtrasadasAgoraCard({ itens, onSelect }: AtrasadasAgoraCardProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-montserrat text-base font-semibold text-gray-900">Urgentes Agora</h3>
        <span className="rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-800">{itens.length}</span>
      </div>
      {itens.length === 0 ? (
        <p className="text-sm text-gray-400">Nenhuma Solicitação urgente no momento.</p>
      ) : (
        <ul className="max-h-72 space-y-1 overflow-y-auto">
          {itens.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => onSelect(item.id)}
                className="flex w-full items-center justify-between rounded-md px-2 py-1.5 text-left text-sm hover:bg-gray-50"
              >
                <span className="truncate">
                  <span className="font-medium text-gray-900">{item.colaboradorNome}</span>
                  <span className="ml-1 text-gray-400">· {item.tipoLabel}</span>
                </span>
                <span className="ml-2 flex-shrink-0 rounded-full bg-red-100 px-1.5 py-0.5 text-xs font-semibold text-red-800">
                  {item.alertaTexto}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
